(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.count-item h2').forEach(counter => {
  const target = +counter.getAttribute('data-count');
  let current = 0;

  const update = () => {
    const increment = target / 60;
    current += increment;

    if (current < target) {
      counter.innerText = Math.ceil(current);
      requestAnimationFrame(update);
    } else {
      counter.innerText = target;
    }
  };

  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hex.big h2').forEach(counter => {
  const target = +counter.getAttribute('data-count');
  let current = 0;

  const update = () => {
    const increment = target / 60;
    current += increment;

    if (current < target) {
      counter.innerText = Math.ceil(current);
      requestAnimationFrame(update);
    } else {
      counter.innerText = target;
    }
  };

  update();
});

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.animate-flow');
  if (!container) return;

  const fades = container.querySelectorAll('.fade-item');

  // start animation
  setTimeout(() => {
    container.classList.add('start');
  }, 50);

  // reveal text sequentially
  fades.forEach((el, index) => {
    setTimeout(() => {
      el.classList.add('show');
    }, 600 + index * 200);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({ note: event.target.value });
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-core"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const items = document.querySelectorAll(".outlast-product");
        if (items.length > 0) {
            items[0].classList.add("hovered");
        }
        items.forEach((item) => {
            item.addEventListener("mouseenter", () => {
            items.forEach((i) => i.classList.remove("hovered"));
            item.classList.add("hovered");
            });
            item.addEventListener("mouseleave", () => {
            });
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
        new Splide('#outlastSplide', {
            perPage: 2,
            gap: '10px',
            pagination: false,
            arrows: false,
            autoplay: false,
            padding: {
                left: '0',
                right: '20px'
            },
            breakpoints: {
                576: {
                    perPage: 1   
                }
            }
        }).mount();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-we-solve"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.flip-btn');
  if (!btn) return;

  const card = btn.closest('.flip-card');
  card.classList.toggle('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workflow"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const workflowItems = document.querySelectorAll(".workflow-item");
  const isMobile = window.innerWidth <= 767;

  workflowItems.forEach((item, index) => {
    const title = item.querySelector(".workflow-title");
    const steps = item.querySelector(".steps");
    const arrow = item.querySelector(".arrow-svg");
    const stepItems = item.querySelectorAll(".step");

    // 👉 MOBILE: open ALL items
    // if (isMobile) {
    //   steps.classList.add("active");
    //   item.classList.add("active");
    //   arrow.style.transform = "rotate(180deg)";

    //   stepItems.forEach((step, i) => {
    //     step.style.transitionDelay = `${i * 0.15}s`;
    //   });
    // }

    // 👉 DESKTOP: open ONLY first item
    // if (!isMobile && index === 0) {
    if (index === 0) {
      steps.classList.add("active");
      item.classList.add("active");
      arrow.style.transform = "rotate(180deg)";

      stepItems.forEach((step, i) => {
        step.style.transitionDelay = `${i * 0.15}s`;
      });
    }

    title.addEventListener("click", () => {
      const isOpen = steps.classList.contains("active");

      if (isOpen) {
        steps.classList.remove("active");
        item.classList.remove("active");
        arrow.style.transform = "rotate(0deg)";
      } else {
        steps.classList.add("active");
        item.classList.add("active");
        arrow.style.transform = "rotate(180deg)";

        stepItems.forEach((step, i) => {
          step.style.transitionDelay = `${i * 0.15}s`;
        });
      }
    });
  });
});




  } catch(e) { console.error(e); }
})();
})();
